import * as React from 'react';
import Routes from 'kts-platform-frame/entry/Routes';
import { MyStore } from 'kts-platform-frame/redux';
import { Provider } from 'react-redux';
import { LocaleProvider } from 'antd';
import { ConfigProvider } from 'kts-components-antd-x4';
import zhCN1 from 'kts-components-antd-x4/lib/locale/zh_CN';
import zhCN from 'antd/lib/locale-provider/zh_CN';



try {
    window.document.domain = window.location.host.split('.').slice(-2).join('.').split(':')[0];
} catch (er) {
    console.error('domain设置失败。');
}

// 设置时区 
import moment from 'moment';
import 'moment/locale/zh-cn';
moment.locale('zh-cn');
class App extends React.PureComponent {
    render() {
        return (
            <LocaleProvider locale={zhCN}>
                <ConfigProvider locale={zhCN1}>
                    <Provider store={MyStore.instance.store}>
                        <Routes />
                    </Provider>
                </ConfigProvider>
            </LocaleProvider >
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.tsx